import { deleteToken } from 'src/utils/token';
import { useCountdownSeconds } from 'src/hooks/use_countdown';
import { useEffect } from 'react';
import { useBoolean } from 'src/hooks/use_boolean';
import { useTranslation } from 'react-i18next';
import authStore from 'src/stores/auth_store';
import { toBool } from 'src/utils/type_check';
import { print } from 'src/utils/log';
import { confirmable } from 'react-confirm';
import StackedModal from './stacked_modal';
import { Box, Typography } from '@mui/material';

function TokenDialog({ show, proceed }) {
  const { t } = useTranslation();
  const { refresh, logout } = authStore();
  const { countdown, startCountdown, stopCountdown } = useCountdownSeconds(60);
  const refreshClicked = useBoolean();

  useEffect(() => {
    if (toBool(show)) {
      startCountdown();
      refreshClicked.onFalse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  useEffect(() => {
    if (!countdown && !refreshClicked.value) {
      deleteToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdown]);

  print('token_dialog load');

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  const modalContent = (
    <Box sx={{ textAlign: 'center' }}>
      <Typography
        variant="body1"
        sx={{ mb: 2, color: 'var(--p-color-text)' }}
      >
        {t('common:timeout.content')}
      </Typography>
      <Typography
        variant="h3"
        sx={{
          mb: 3,
          fontSize: '48px',
          fontWeight: 'bold',
          color: 'var(--p-color-text-critical)',
        }}
      >
        {formatTime(countdown)}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: 'var(--p-color-text-secondary)' }}
      >
        {t('common:timeout.placeholder')}
      </Typography>
    </Box>
  );

  return (
    <StackedModal
      isOpen={show}
      title={t('common:timeout.title')}
      content={modalContent}
      secondaryAction={{
        content: t('common:button.logout'),
        onAction: async () => {
          stopCountdown();
          await logout();
          proceed(false);
        },
      }}
      primaryAction={{
        content: t('common:button.extend_session'),
        onAction: async () => {
          stopCountdown();
          refreshClicked.onTrue();
          await refresh();
          proceed(true);
        },
      }}
      onClose={() => {
        deleteToken();
        stopCountdown();
        proceed(false);
      }}
    />
  );
}

export default confirmable(TokenDialog);
